
$(document).ready(function () {
    // Mobile Navigation
    var navContainer = $('.mobile__nav');
    var menuBtn = $('.mobile__menuIcon');

    menuBtn.click(function(){
        menuBtn.toggleClass('open');
        navContainer.slideToggle();
        $("body").toggleClass('no-scroll');

    });

    $(window).resize(function(){
        // Mobile Menu
        if ($(window).width() >= 768){
            $('.mobile__nav').hide();
            menuBtn.removeClass('open');
        }
    });

    if ($(window).width() >= 768){
        $('.mobile__nav').hide();
    }

    // Create Arrow Per Drop Down

    $('.menu-item-has-children > a').append('<div class="mobile__arrow"></div>');

    // And for priority nav MORE
    $('.priority-nav__wrapper').append('<div class="mobile__arrow"></div>');


    $('.nav__dropdown-toggle').click( function() {
        $('.sub-menu').closest().hide();

        var mobileArrows = $('.mobile__arrow');

        if( mobileArrows.hasClass('active') ) {
            mobileArrows.removeClass('active');
        }

        if( mobileArrows.hasClass('mobile__arrow--active') ) {
            mobileArrows.removeClass('mobile__arrow--active');
        }

    });



    // Event Delegation for nav dropdowns for tablet/mobile
    function addClickForDropdowns() {
        $('body').click( function(e) {

            // Click handler for stories link on archive page
            if ( (e.target && e.target.matches('div') && e.target.matches('div.mobile__arrow') && $(e.target).closest('.mobile__nav').hasClass('mobile__nav')) ) {
                e.stopPropagation();
                e.preventDefault();

                e.target.classList.toggle('mobile__arrow--active');

                if( e.target.parentNode.parentNode.classList.contains('nav-item__active') ) {
                    e.target.parentNode.parentNode.classList.remove('nav-item__active');
                } else {
                    e.target.parentNode.parentNode.classList.add('nav-item__active');
                }

                // e.target.parentNode.parentNode.querySelector(':scope > .sub-menu').classList.toggle('sub-menu--active');
                $(e.target).closest('.menu-item').find('.sub-menu').slideToggle();

            } else {
                // Else remove active nav states
                $('.menu-item-has-children').removeClass('nav-item__active');
                $('.sub-menu').removeClass('sub-menu--active');
                $('.mobile__arrow').removeClass('mobile__arrow--active');
            }
        });
    }

    addClickForDropdowns();


});



// WEBPACK FOOTER //
// ./nav.js